
import {WOW} from '../../../node_modules/wowjs/dist/wow';
// import './rem.js'

new WOW().init();


const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (entry.isIntersecting) {
const img = entry.target;
img.src = img.dataset.src;
observer.unobserve(img);
}
});
}, { rootMargin: '200px' }); // 预加载200px
document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));

$(".quote input").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".quote input").blur(function() {
    $(this).css("border","none")
})
$(".quote textarea").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".quote textarea").blur(function() {
    $(this).css("border","none")
})
$(".pop input").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".pop input").blur(function() {
    $(this).css("border","none")
})
$(".pop textarea").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".pop textarea").blur(function() {
    $(this).css("border","none")
})
$(".pop-btn").click(function() {
    $(".pop").css('display','flex');
})
$(".pop .model").click(function() {
    $(".pop").hide();
})
$(".pop .out").click(function() {
    $(".pop").hide();
})